import { Grid, LinearProgress } from '@material-ui/core';
import ButtonCommon from "../../components/ButtonCommon";
import CommonModal from '../../components/CommonModal';
import InputCommon from '../../components/InputCommon';
import CustomAlerts from "../../components/AlertCustom.js";
import { useState, useRef, useEffect, Fragment } from 'react';
import { CloseOutlined } from '@material-ui/icons';
import GreenDownload from '../../assets/GreenDownload';
import SnapGreen from '../../assets/SnapGreen';
import './index.scss';
import { createPaymentSession, uploadChallanFile } from '../../api/challan'
import CircularProgress from '@material-ui/core/CircularProgress';

const PayModalChalan = ({ open, closeModal, refetchData }) => {

    const [ rightModal , setRightModal ] = useState(false);
    const [form, setForm] = useState({amount: null, file: null});
    const [loading, setLoading] = useState(false);
    const [sessionData, setSessionData] = useState({});
    const [uploading, setUploading] = useState(false);
    const [error , ShowError] = useState(false);
    const fileRef = useRef(null);
    const iframeRef = useRef(null);

    useEffect(() => {
      setSessionData({})
    },[])

    const onChange = (key, value) => {
      const currentForm = {...form};
      currentForm[key] = value;
      setForm(currentForm)
    }

    const onSubmit = () => {
      if(!form.amount) {
        return
      }
      setLoading(true);
      const { amount, file } = form
      createPaymentSession(amount, file).then(res => {
        setLoading(false);
        setSessionData(res);
      }).catch(err => {
        setLoading(false);
        CustomAlerts({
          message : err.message,
          title:'Error',
          type:'danger'
        })
      })
    }

    const postPayment = () => {
      refetchData();
      onModalClose();
    }

    useEffect(() => {
      window.addEventListener('message', (event) => {
        if(event?.data?.detail?.paymentStatus === "CANCELLED") {
          onModalClose();
        } else if(event?.data?.detail?.paymentStatus === "SUCCESS") {
          postPayment();
        }
      })
      return (
        window.removeEventListener('message', this)
      )
    },[sessionData.sessionUrl])

    const renderModalContent = () => {
      if(uploading) {
        return <Fragment>
          <div className="successCon">
            <div className="iconCon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 450" preserveAspectRatio="xMidYMid slice"><defs><clipPath id="__lottie_element_2"><rect x={0} y={0} /></clipPath></defs><g clipPath="url(#__lottie_element_2)"><g transform="matrix(0.522450864315033,0,0,0.522450864315033,213.0410919189453,208.0526885986328)" opacity="0.3" style={{display: 'block'}}><g opacity={1} transform="matrix(1,0,0,1,2.9140000343322754,13.633000373840332)"><path fill="rgb(33,206,153)" fillOpacity={1} d=" M0,-103.1875 C56.949180603027344,-103.1875 103.1875,-56.949180603027344 103.1875,0 C103.1875,56.949180603027344 56.949180603027344,103.1875 0,103.1875 C-56.949180603027344,103.1875 -103.1875,56.949180603027344 -103.1875,0 C-103.1875,-56.949180603027344 -56.949180603027344,-103.1875 0,-103.1875z" /><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity={0} strokeMiterlimit={4} stroke="rgb(128,240,206)" strokeOpacity={1} strokeWidth={0} d=" M0,-103.1875 C56.949180603027344,-103.1875 103.1875,-56.949180603027344 103.1875,0 C103.1875,56.949180603027344 56.949180603027344,103.1875 0,103.1875 C-56.949180603027344,103.1875 -103.1875,56.949180603027344 -103.1875,0 C-103.1875,-56.949180603027344 -56.949180603027344,-103.1875 0,-103.1875z" /></g></g><g transform="matrix(0.49381715059280396,0,0,0.49381715059280396,213.09835815429688,208.4535675048828)" opacity="0.3" style={{display: 'block'}}><g opacity={1} transform="matrix(1,0,0,1,2.9140000343322754,13.633000373840332)"><path fill="rgb(33,206,153)" fillOpacity={1} d=" M0,-103.1875 C56.949180603027344,-103.1875 103.1875,-56.949180603027344 103.1875,0 C103.1875,56.949180603027344 56.949180603027344,103.1875 0,103.1875 C-56.949180603027344,103.1875 -103.1875,56.949180603027344 -103.1875,0 C-103.1875,-56.949180603027344 -56.949180603027344,-103.1875 0,-103.1875z" /><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity={0} strokeMiterlimit={4} stroke="rgb(128,240,206)" strokeOpacity={1} strokeWidth={0} d=" M0,-103.1875 C56.949180603027344,-103.1875 103.1875,-56.949180603027344 103.1875,0 C103.1875,56.949180603027344 56.949180603027344,103.1875 0,103.1875 C-56.949180603027344,103.1875 -103.1875,56.949180603027344 -103.1875,0 C-103.1875,-56.949180603027344 -56.949180603027344,-103.1875 0,-103.1875z" /></g></g><g transform="matrix(0.4353572130203247,0,0,0.4353572130203247,213.2152862548828,209.27200317382812)" opacity="0.4" style={{display: 'block'}}><g opacity={1} transform="matrix(1,0,0,1,2.9140000343322754,13.633000373840332)"><path fill="rgb(33,206,153)" fillOpacity={1} d=" M0,-103.1875 C56.949180603027344,-103.1875 103.1875,-56.949180603027344 103.1875,0 C103.1875,56.949180603027344 56.949180603027344,103.1875 0,103.1875 C-56.949180603027344,103.1875 -103.1875,56.949180603027344 -103.1875,0 C-103.1875,-56.949180603027344 -56.949180603027344,-103.1875 0,-103.1875z" /><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity={0} strokeMiterlimit={4} stroke="rgb(128,240,206)" strokeOpacity={1} strokeWidth={0} d=" M0,-103.1875 C56.949180603027344,-103.1875 103.1875,-56.949180603027344 103.1875,0 C103.1875,56.949180603027344 56.949180603027344,103.1875 0,103.1875 C-56.949180603027344,103.1875 -103.1875,56.949180603027344 -103.1875,0 C-103.1875,-56.949180603027344 -56.949180603027344,-103.1875 0,-103.1875z" /></g></g><g transform="matrix(0.550000011920929,0,0,0.550000011920929,212.98599243164062,207.66700744628906)" opacity={1} style={{display: 'block'}}><g opacity={1} transform="matrix(1,0,0,1,2.9140000343322754,13.633000373840332)"><path fill="rgb(33,206,153)" fillOpacity={1} d=" M0,-103.1875 C56.949180603027344,-103.1875 103.1875,-56.949180603027344 103.1875,0 C103.1875,56.949180603027344 56.949180603027344,103.1875 0,103.1875 C-56.949180603027344,103.1875 -103.1875,56.949180603027344 -103.1875,0 C-103.1875,-56.949180603027344 -56.949180603027344,-103.1875 0,-103.1875z" /><path strokeLinecap="butt" strokeLinejoin="miter" fillOpacity={0} strokeMiterlimit={4} stroke="rgb(128,240,206)" strokeOpacity={1} strokeWidth={0} d=" M0,-103.1875 C56.949180603027344,-103.1875 103.1875,-56.949180603027344 103.1875,0 C103.1875,56.949180603027344 56.949180603027344,103.1875 0,103.1875 C-56.949180603027344,103.1875 -103.1875,56.949180603027344 -103.1875,0 C-103.1875,-56.949180603027344 -56.949180603027344,-103.1875 0,-103.1875z" /></g></g><g transform="matrix(0.5,0,0,0.5,214.4949951171875,214.71299743652344)" opacity={1} style={{display: 'block'}}><g opacity={1} transform="matrix(3,0,0,3,0,0)"><path fill="rgb(255,255,255)" fillOpacity={1} d=" M15.059000015258789,-7.880000114440918 C15.059000015258789,-7.880000114440918 -3.440999984741211,10.619999885559082 -3.440999984741211,10.619999885559082 C-3.811000108718872,11 -4.310999870300293,11.1899995803833 -4.810999870300293,11.1899995803833 C-5.301000118255615,11.1899995803833 -5.801000118255615,11 -6.181000232696533,10.619999885559082 C-6.181000232696533,10.619999885559082 -15.060999870300293,1.7400000095367432 -15.060999870300293,1.7400000095367432 C-15.821000099182129,0.9800000190734863 -15.821000099182129,-0.25 -15.060999870300293,-1.0099999904632568 C-14.300999641418457,-1.7599999904632568 -13.081000328063965,-1.7599999904632568 -12.321000099182129,-1.0099999904632568 C-12.321000099182129,-1.0099999904632568 -4.810999870300293,6.510000228881836 -4.810999870300293,6.510000228881836 C-4.810999870300293,6.510000228881836 12.319000244140625,-10.619999885559082 12.319000244140625,-10.619999885559082 C13.079000473022461,-11.380000114440918 14.309000015258789,-11.380000114440918 15.059000015258789,-10.619999885559082 C15.819000244140625,-9.859999656677246 15.819000244140625,-8.640000343322754 15.059000015258789,-7.880000114440918z" /></g></g><g style={{display: 'none'}}><g><path /></g></g><g style={{display: 'none'}}><g><path /></g></g><g style={{display: 'none'}}><g><path /></g></g><g style={{display: 'none'}}><g><path /></g></g></g></svg>
            </div>
            <h3>Payment Successfull</h3>
            <div className="transId">
              Transaction ID: <b>{sessionData.transactionId}</b>
            </div>

            <h4>Uploading Challan Now</h4>
            <div className="uploadingBox">
              <CircularProgress />
            </div>
          </div>
        </Fragment>
      } else if (sessionData?.url) {
        return <Grid container>
          <Grid md={12}>
            <div className="modalMain">
              <iframe src={sessionData.url} ref={iframeRef} />
            </div>
          </Grid>
        </Grid>
      } else {
        return <Grid container>
          <Grid md={12}>
            <div className="modalMain">
              <h1>Enter amount as per your GST challan</h1>
              <ul>
                <li>When creating challan, select the payment mode as NEFT/RTGS</li>
                <li>Verify and enter accurate challan value to avoid delay in disbursal.</li>
                <li>Requested amount will be credited to your GST cash ledger in a few hours and maximum one working day.</li>
                <li>If there is delay due to government portal slowness or internet banking issues, ClearTax or its associated partners will not be responsible for the delayed payment.</li>
              </ul>
              <div className="amountContainer">
                <Grid container spacing={3}>
                  <Grid md="4" item>
                    <InputCommon 
                      value={form.amount}
                      onChange={(e) => onChange('amount', e.target.value)}
                      type="number"
                      placeholder="Enter Amount"
                    />
                    <p>{error}</p>
                  </Grid>
                  <Grid md="8" item>
                    {form.file ?
                      <div className="uploadedCon">
                        <span>{form?.file?.name}</span> <a onClick={() => fileRef.current.click()}>REUPLOAD</a>
                      </div>
                      :
                      <Grid container spacing="3">
                        <Grid item md="6">
                          <ButtonCommon onClick={() => fileRef.current.click()} className="reverted" title="Upload GST Challan" />
                        </Grid>
                      </Grid>
                    }
                  </Grid>
                  <Grid item md="8">
                    <ButtonCommon disabled={isDisabled() || loading} onClick={() => onSubmit()} title={loading ? "Processing" : "Proceed to see EMI options"} />
                  </Grid>
                </Grid>
              </div>

              <input 
                type="file" 
                onChange={(e) => onChange('file', e.target.files[0])}
                ref={fileRef}
                style={{display: 'none'}}
                accept="application/pdf"
              />              
            </div>
          </Grid>
        </Grid>
      }
    }

    const isDisabled = () => {
      if (!form.amount || !form.file) {
        return true;
      }
      return false;
    }

    const onModalClose = () => {
      setForm({amount: null, file: null});
      setSessionData({}); 
      closeModal();
    }

    return (
      <CommonModal maxWidth="md" open={open} style={{width: '100%'}}>
        <div onClick={() => { onModalClose() }} className="modalCloseBtn">
          <CloseOutlined />
        </div>
        {renderModalContent()}
      </CommonModal>
    )
}

export default PayModalChalan;